import React from 'react';
import Loading from '../../../loading';
import Server from '../../../../functions/server'
import $ from "jquery";
import { Grid, Dropdown, Input, Button } from 'semantic-ui-react';
import Featureimage from './featureimage';
import Images from '../../image'

class BrandImage extends React.Component {

  state = {
    brandOption: [],
    image: false
  }

  componentDidMount() {
    this.getPartCode();
  }

  componentDidUpdate(props) {
    if (props.partno != this.props.partno) {
      this.getPartCode();
    }
  }

  getPartCode() {
    let context = this;
    context.setState({
      load: true,
      image: false,
      message: 'Getting PartCode!!!'
    });
    let data1 = { 'partno': this.props.partno };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'addmenu/branddetails/getallpartcode.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        data = JSON.parse(data);
        console.log(data);
        context.setBrand(data);
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  setBrand(data) {
    let context = this;
    var x = [];
    data.map((y) => {
      let name = y.brand_id + ' -> ' + y.brand;
      x.push({key: name, text: name, value: y.part_code});
    });
    try {
      context.setState({
        brandOption: x,
      });
    } catch (e) {

    }
  }

  brand = (f, { value }) => {
    this.setState({
      value: value,
      image: true
    });
  }

  render() {
    const { load, message, value, image } = this.state;
    return (
      <div style={{padding: '2%'}}>
        <Loading load={load} message={message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            Choose Brand<br/>
            <Dropdown
              id="brand" onChange={this.brand} fluid focus
              search selection options={this.state.brandOption}
              value={value} />
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
          { image ?
            (
              <div>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Featureimage partCode={this.state.value} />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Images partCode={this.state.value} />
                  </Grid.Column>
                </Grid>
              </div>
            ) :
            (
              <div></div>
            )
          }
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default BrandImage;
